import React from 'react';
import ReactDOM from 'react-dom/client';
import './src/index.css';
import App from './App';
import { installOttawaTimezone } from './services/appTimezone';
import { startBuildWatch } from './services/buildVersion';
import { startLiveDatabaseWatch } from './services/liveDatabase';

// Every displayed date/time reads in Ottawa time, on every machine (in-house
// software for an Ottawa operation). Must run before the first render.
installOttawaTimezone();

// STALE TAB AFTER A DEPLOY (2026-09-21). Every build renames the page chunks
// (ForwardedInbox-<hash>.js …) and Netlify deploys atomically, so a tab opened
// before a deploy asks for a chunk that no longer exists the first time it
// visits that page — "Failed to fetch dynamically imported module", the error
// card, and a manual Reload. Vite raises `vite:preloadError` for exactly this;
// reload once so the tab picks up the new build on its own. Guarded so a
// build that is genuinely broken cannot loop: one reload per tab session.
window.addEventListener('vite:preloadError', (event) => {
  const key = 'wd:preload-reloaded';
  let already = false;
  try { already = sessionStorage.getItem(key) === '1'; if (!already) sessionStorage.setItem(key, '1'); } catch { /* private mode */ }
  if (already) return;
  event.preventDefault();
  window.location.reload();
});

// NEW BUILD WHILE THE TAB IS OPEN (2026-09-21). The preload guard above only
// fires when a stale tab happens to open a page whose chunk is gone; a tab
// that stays on one screen keeps running the old code indefinitely — which is
// how tabs from before the board fix wiped 565 live cards the next morning.
// Poll /version.json and reload at the next quiet moment (see the module).
startBuildWatch();

// THE DATABASE IN USE (backup plan, 2026-10-23). After a database-only switch this site talks to the backup
// database; the watch asks it at once, every 30 s while shown, and reloads the page once when the answer
// changes (services/liveDatabase.ts). Off unless the backup switch is on for this site.
startLiveDatabaseWatch();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);